import request from '@/units/request';

export default {
  list: (data) =>
    request({
      url: 'link/index',
      method: 'GET',
      custom: {
        showLoading: false,
        auth: true,
      },
    }),
};



// WEBPACK FOOTER //
// ./src/api/link.js